module.exports = __webpack_public_path__ + "media/images/front/home_video-15a90f30e3d20af923cee063ceb5bbe9.mp4";